












import Vue from 'vue';

import { mapActions, mapState } from 'vuex';
import { HubLoading } from '../components/HubComponents';

export default Vue.extend({
  name: 'ViewLoginHub',
  components: {
    HubLoading,
  },
  props: {
    page: {
      type: String as () => Store.User.Page,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState(['user']),
  },
  mounted() {
    this.validateToken({
      token: this.token,
      page: this.page,
    })
      .finally(() => {
        const errorParams = {
          error: '401',
          title: 'Acesso não autorizado!',
          message: 'Tente refazer o login pelo sistema.',
        };
        const redirectPage = this.user.logged ? this.firstCapitalLetter(this.user.page) : 'Error';
        this.loading = false;
        this.$router.push({
          name: redirectPage,
          params: this.user.logged ? undefined : errorParams,
        });
      });
  },
  methods: {
    ...mapActions('user', ['validateToken']),
    firstCapitalLetter(value: string): string {
      return `${value.slice(0, 1).toUpperCase()}${value.slice(1).toLowerCase()}`;
    },
  },
});
